import noBookCover from '../assets/no-book-cover.png';
import { resolveApiAsset } from '../config/urls';

const PLACEHOLDER = noBookCover;

export const getAdminBookImage = (source) => {
  const value = String(source || '').trim();
  if (!value) return PLACEHOLDER;
  return resolveApiAsset(value);
};

export const handleAdminBookImageError = (event) => {
  if (event.currentTarget.getAttribute('src') !== PLACEHOLDER) {
    event.currentTarget.src = PLACEHOLDER;
  }
};
